/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC, useEffect, useState } from "react";
import FilterListIcon from "@mui/icons-material/FilterList";
import { MdOutlineErrorOutline } from "react-icons/md";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { useAppDispatch } from "../../../useStore";
import { reset } from "../../../features/Applicant/applicantSlice";
import {
  EntriesPerPage,
  Search,
  TableFetch,
} from "../../../components/TableOptions";
import Pagination from "../../../components/Pagination";
import EvalvationModal from "../../../components/ModalComponents/EvalvationModal";
import swal from "sweetalert";
import moment from "moment";
import ScreeningUpdateModal from "../../../components/ModalComponents/ScreeningUpdateModal";
import toast, { Toaster } from "react-hot-toast";
import XLoader from "../../../components/XLoader";
import DropOutModal from "../../../components/ModalComponents/DropOutModal";
import { FaFilePdf, FaFileCsv, FaFileImage, FaFile } from "react-icons/fa";
import PdfViewer from "../../../components/PdfViewer";
import ImageLightbox from "../../../components/ImageLightbox";
import EditApplicant from "../../../components/ModalComponents/EditApplicant";
import ReplaceID from "../../../components/ModalComponents/ReplaceID";
import EvaluationDrawerComponent from "../ApplicantDrawerComponent/EvaluationDrawerComponent";

interface Props {
  pageHeader?: any;
  statusButton?: any;
  Status?: any;
  headerTitles: Array<string>;
  title?: string;
  isLoading?: any;
  data: any;
  message: any;
  isError: any;
  setResetID: any
}

const ScreeningTable: FC<Props> = ({
  setResetID,
  pageHeader,
  headerTitles,
  statusButton,
  Status,
  data,
  isLoading,
  message,
  isError
}: any) => {
  const [datas, setDatas] = useState([]);
 
  const [searchItem, setSearchItem] = useState("");
  const [entriesperpage, setEntriesPerPage] = useState(() => {
    return "8";
  });

  // console.log('datas', datas);
  const dispatch = useAppDispatch();
  const [show, setShow] = useState(false);
  const [isPDF, setIsPDF] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedIds, setSelectedIds] = useState<string[]>([]); // State to hold selected IDs
  const [selectedItems, setSelectedItems] = useState<any[]>([]); // State to hold selected items
  const [displayData, setDisplayData] = useState([]);
  const handleCheckboxChange = (itemId: string, item: any) => {
    setIsDrawerOpen(true);
    // Check if the item's ID is already selected
    if (selectedIds.includes(itemId)) {
      // Remove the ID from the selectedIds array
      setSelectedIds(selectedIds.filter((id) => id !== itemId));
      setSelectedItems((prevSelectedItems) => prevSelectedItems.filter((i) => i.id !== itemId));
    } else {
      // Add the ID to the selectedIds array
      setSelectedIds([...selectedIds, itemId]);
      setSelectedItems((prevSelectedItems) => [...prevSelectedItems, item]);
    }
  };


  const openModal = (fileUrl: any, fileType:string, file: React.SetStateAction<null>) => {
    setSelectedFile(file);
    setIsPDF(fileType === 'pdf');
    setShow(true);
  };


  const getFileIcon = (fileType: any) => {
    switch (fileType) {
      case 'pdf':
        return <FaFilePdf color={"red"} size={25} />;
      case 'csv':
        return <FaFileCsv size={25} color={"green"} />;
      case 'jpeg':
      case 'jpg':
      case 'png':
        return <FaFileImage size={25} color={"gray"} />;
      default:
        return <FaFile size={25} />;
    }
  };

  // useEffect(() => {
  //     const input = { applicationStatus: "SCREENING" };
  //     // @ts-ignore 
  //     dispatch(getallapplicant(input))
  //   }, [dispatch])
    
    const toggleDrawer = () => {
      setIsDrawerOpen(!isDrawerOpen);
     };

  useEffect(() => {
    if (isError) {
      swal({
        title: "error",
        text: message,
        icon: "error",
      });
      dispatch(reset());
    }
  }, [dispatch, isError, message]);




  useEffect(() => {
    const result = data?.data?.filter((item: any) =>
      item?.firstName?.toLowerCase()?.includes(searchItem) ||
      item?.middleName?.toLowerCase()?.includes(searchItem) ||
      item?.LastName?.toLowerCase()?.includes(searchItem)
    );
    setDatas(result);
  }, [data, searchItem]);



  const handleShow = () => {
    toast.error("Screening have not been Completed")
  }

  return (
    <div>
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 5000,
          error: {
            duration: 20000,
          },
        }}
      />
      <section className="md-ui component-data-table">
        <header className="main-table-header">
          <div className="main-table-search-container">
            <h1 className="table-header--title">{pageHeader}</h1>
            <Search
              searchItem={searchItem}
              setSearchItem={setSearchItem}
              placeholder={pageHeader}
            />
            <div>
              <EntriesPerPage
                data={datas}
                entriesperpage={entriesperpage}
                setEntriesPerPage={setEntriesPerPage}
              />
            </div>
            <span className="table-header--icons">
              <FilterListIcon />
            </span>
          </div>
        </header>
        {isLoading && <XLoader isLoading={isLoading} />}
        <div className="main-table-wrapper">
          <table className="main-table-content">
            <thead className="data-table-header">
              <tr className="data-table-row">
                {headerTitles.map((title, i) => (
                  <td
                    className="table-datacell datatype-string headerTitles"
                    key={i}
                  >
                    {title}
                  </td>
                ))}
              </tr>
            </thead>
            <tbody className="data-table-content">
              {isLoading ? (
                <TableFetch colSpan={15} />
              ) : displayData?.length === 0 ||
                displayData?.length === undefined ? (
                <tr>
                  <td className="table-msg" colSpan={15}>
                    <MdOutlineErrorOutline size={75} />
                    <p>No Record found!</p>
                  </td>
                </tr>
              ) : (
                displayData?.map((item: any, i: any) => (
                  <tr className="data-table-row" key={i}>
                        <td>
  {item?.ScreeningLog?.screeningStatus === "PENDING" ? ( 
    (  <div className="md-checkbox">
      <input
        id={i}
        type="checkbox"
        onClick={handleShow} 
      />
      <label htmlFor={i}></label>
    </div>)
  ) : (
    <div className="md-checkbox">
    <input
      id={i}
      type="checkbox"
      checked={selectedIds?.includes(item?.id)}
      onChange={() => handleCheckboxChange(item?.id, item)}
    />
    <label htmlFor={i}></label>
  </div>
  )}
</td>

                    <td className="table-datacell datatype-string">
                      <div className="dropdown">
                        <button className="dropbtn">
                          <MoreHorizIcon />
                        </button>

                        <div className="dropdown-content">
                          <a>
                            {item?.ScreeningLog?.screeningStatus === "PENDING" ? (
                              <div onClick={handleShow}>Send for Evaluation</div>
                            ) : (
                              <EvalvationModal
                                title="Send for Evaluation"
                                nametitle={item?.title}
                                name={[item]}
                                id={item?.id}
                              />
                            )}
                          </a>

                          <a>
                            {item?.EvaluatingLog?.evaluatingStatus === "PENDING" ? (
                              <div onClick={handleShow}>Dropout</div>
                            ) : (
                              <DropOutModal
                                title="Dropout"
                                id={item?.id}
                                name={`${!item?.firstName ? "" : item?.firstName} ${!item?.middleName ? "" : item.middleName} ${!item?.LastName ? "" : item?.LastName}`.trim()}
                              />
                            )}
                          </a>
                        </div>
                      </div>
                    </td>
                    <td className="table-datacell datatype-string">
                      <div className="dropdown">
                        <ScreeningUpdateModal
                          disabled={item?.ScreeningLog?.screeningStatus !== "PENDING"}
                          title="Send for Screening"
                          nametitle={item.title}
                          name={`${item.firstName ?? ''} ${item.middleName ?? ''} ${item.LastName ?? ''}`}
                          id={item?.ScreeningLog?.id}
                        />
                      </div>
                    </td>
                    <td className="table-datacell datatype-numeric toggle">
                      {item.title}
                    </td>

                    <td className="table-datacell datatype-string">
                      {item.firstName + " " + item.LastName}
                    </td>
                    <td className="table-datacell datatype-string">
                      {item?.gender}
                    </td>
                    <td className="table-datacell datatype-string">
                      {moment(!item?.dateOfBirth ? "n/a" : item?.dateOfBirth).format("DD-MM-YYYY")}
                    </td>
                    <td className="table-datacell datatype-string">
                      <Link
                        to={`/viewapplicants/${item?.id}`}
                        className="applicant-btn"
                      >
                        <Button className="view-job-profile">View</Button>
                      </Link>
                    </td>

                    <td className="table-datacell datatype-string">
                      {item?.verificationID
                       ? (

                        <div className="table-datacell-flex">
                          <span
                            style={{ marginRight: '5px', cursor: 'pointer' }}
                            onClick={() => {
                              const fileExtension = item?.verificationID.split('.').pop().toLowerCase();
                              openModal(item?.verificationID, fileExtension, item?.verificationID                                ,);
                            }}>
                            {getFileIcon(item?.verificationID.split('.').pop().toLowerCase())}
                          </span>
                          <ReplaceID id={item?.id} setResetID={setResetID} />
                        </div>  
                        )
                        : <div className="table-datacell-flex">
                         <span>
                          No ID
                         </span>
                         <ReplaceID id={item?.id} setResetID={setResetID} />
                        </div>
                      }
                    </td>
                    <td className="table-datacell datatype-string">
                      {" "}
                      {moment(item?.createdAt).format("DD-MM-YYYY")}
                    </td>

                    <td className="table-datacell datatype-numeric">
                      <Button className={statusButton}
                      >{item?.ScreeningLog?.screeningStatus === "PENDING" ? Status : "COMPLETED"}</Button>
                    </td>

                    <td className="table-datacell datatype-numeric">
                      {!item.phoneNumber ? "n/a" : item?.phoneNumber}
                    </td>
                    <td className="table-datacell datatype-numeric">
                      {item?.applicationStatus}
                    </td>

                    <td className="table-datacell datatype-numeric">
                      {!item.totalWorkExperience
                        ? "n/a"
                        : item?.totalWorkExperience + " years"}
                    </td>
                    <td className="table-datacell datatype-string">
                      {!item?.email ? "n/a" : item?.email}
                    </td>
                    <td className="table-datacell datatype-string">
                      {!item?.location ? "n/a" : item?.location}
                    </td>
                    <td className="table-datacell datatype-string">
                      <EditApplicant name={item} id={item?.id} />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
          {isPDF ? (
            <PdfViewer fileUrl={selectedFile} setShow={setShow} show={show} />
          ) : (
            <ImageLightbox images={selectedFile} setShow={setShow} show={show} />
          )}
        </div>
        <div className="table-footer">
          <div>
            <Pagination
              setDisplayData={setDisplayData}
              data={datas}
              entriesperpage={entriesperpage}
              Total={"Screening"}
            />
          </div>
          <EvaluationDrawerComponent 
           isOpen={
            isDrawerOpen &&
            selectedItems.every(
              (item) => item?.ScreeningLog?.screeningStatus === "COMPLETED"
            )
              }
              onClose={toggleDrawer}
               data={selectedItems.filter(
               (item) => item?.ScreeningLog?.screeningStatus === "COMPLETED"
            )}
               id={selectedIds.filter((id) => {
               const selectedItem = selectedItems.find((item) => item.id === id);
               return selectedItem?.ScreeningLog?.screeningStatus === "COMPLETED";
            })}
          />
        </div>
      </section >
    </div >
  );
};

export default ScreeningTable;
